import React from "react";

import FeaturePromoPanel from "@ats/src/components/shared/FeaturePromoPanel";
import PlatoPromoGraphic from "@ats/src/components/shared/PlatoPromoGraphic";

/**
 * The Plato launch content, bound to the reusable panel.
 *
 * This is the only file a future feature launch needs to fork: copy it, change
 * the copy below, and pass a different artwork component as children. Nothing
 * about layout, chrome, or responsive behaviour lives here.
 */

export default function PlatoAuthPromo() {
  return (
    <FeaturePromoPanel
      eyebrow="Now in open beta"
      titleAccent="Plato"
      title="by Polymer"
      description="Every role draws hundreds of applicants. Plato AI reviews and scores each one against your role's criteria — so you review the best first."
      ctaLabel="Learn more"
      ctaHref="https://polymer.co/plato"
    >
      <PlatoPromoGraphic />
    </FeaturePromoPanel>
  );
}
